import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [ready, setReady] = useState(true);

  useEffect(() => {
    // trigger a lightweight fade-in on route change only
    setReady(false);
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, [location.pathname]);

  // Handle scroll: only scroll-to-top on pathname change. Hash scrolling is handled by the destination page to avoid double scroll and extra blank space below footer.
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname]);

  return (
    <div className="page-transition-wrapper">
      <div
        key={location.pathname}
        className={`page-transition ${ready ? 'ready' : ''}`}
      >
        {children}
      </div>
    </div>
  );
};

export default PageTransition;

